import TeamMember from "../../Components/TeamMember/TeamMember";
import "./Team.css";

import willi from "../../Media/team/willi.jpg";
import paul from "../../Media/team/paul.jpg";
// import monika from "../../Media/team/monika.jpg";
// import jonas from "../../Media/team/jonas.jpg";
import samuel from "../../Media/team/samuel.jpg";

export default function Team() {
	return (
		<div className="team">
			<div className="teamContainer">
				<div className="teamBanner">
					<div className="banner" ></div>
				</div>

				<TeamMember img={willi} name={"Willi"} />

				<TeamMember img={paul} name={"Paul"} />

				<TeamMember img={samuel} name={"Samuel"} />

				{/* <TeamMember img={monika} name={"Monika"} /> */}

				{/* <TeamMember img={jonas} name={"Jonas"} /> */}
			</div>
		</div>
	);
}